export interface Distrito {
  slug: string;
  name: string;
  zona: "Norte" | "Sur" | "Centro" | "Este" | "Oeste";
  referencia: string;
  zonas: string[];
  /** Día en que salió su página (YYYY-MM-DD), si no es el de la ruta base (ver `GEO_ROUTES` en seo-pages.ts). */
  publicadoEn?: string;
}

export const DISTRITOS: Distrito[] = [
  {
    slug: "miraflores",
    name: "Miraflores",
    zona: "Sur",
    referencia:
      "Miraflores concentra marcas comerciales, restaurantes, centros de consumo y alto flujo peatonal en la Costa Verde y el Malecón.",
    zonas: [
      "Av. Larco y Centro Comercial Larcomar",
      "Parque Kennedy y alrededores",
      "Malecón de la Reserva y Costa Verde",
    ],
  },
  {
    slug: "san-isidro",
    name: "San Isidro",
    zona: "Centro",
    referencia:
      "San Isidro es el distrito financiero y corporativo de Lima, con sedes de multinacionales, bancos y oficinas centrales.",
    zonas: [
      "Av. Rivera Navarrete y Centro Empresarial",
      "Av. El Bosque y La Floresta",
      "Av. Javier Prado Este (zona bancaria)",
    ],
  },
  {
    slug: "surco",
    name: "Surco",
    zona: "Sur",
    referencia:
      "Santiago de Surco combina residencias de clase media-alta con centros comerciales de alto tráfico como Jockey Plaza y La Rambla.",
    zonas: [
      "Jockey Plaza y Av. Javier Prado Este",
      "Av. Caminos del Inca y Av. Benavides",
      "La Rambla San Borja (zona límite Surco)",
    ],
  },
  {
    slug: "san-borja",
    name: "San Borja",
    zona: "Sur",
    referencia:
      "San Borja es un distrito residencial consolidado con centros cívicos, instituciones del Estado y flujo comercial constante.",
    zonas: [
      "Av. San Luis y Av. Angamos Este",
      "Centro Cívico de San Borja",
      "Av. San Borja Norte (zona institucional)",
    ],
  },
  {
    slug: "la-molina",
    name: "La Molina",
    zona: "Este",
    referencia:
      "La Molina es un distrito residencial de alta penetración de marcas premium con centros comerciales como La Molina Plaza.",
    zonas: [
      "La Molina Plaza y Av. La Molina",
      "Av. Raúl Ferrero y Av. Javier Prado Este",
      "Portales de La Molina y zona universitaria",
    ],
  },
  {
    slug: "jesus-maria",
    name: "Jesús María",
    zona: "Centro",
    referencia:
      "Jesús María es una zona mixta residencial-comercial con alto tráfico peatonal en el Campo de Marte y avenidas principales.",
    zonas: [
      "Campo de Marte y Av. Brasil",
      "Av. Arnaldo Márquez y Av. Cuba",
      "Av. General Garzón y mercados de proximidad",
    ],
  },
  {
    slug: "lince",
    name: "Lince",
    zona: "Centro",
    referencia:
      "Lince es un distrito compacto con flujo comercial activo en Arequipa y Petit Thouars, y mercados de consumo masivo.",
    zonas: [
      "Av. Arequipa (cuadras 27–34)",
      "Av. Petit Thouars y mercados",
      "Av. Arenales y comercio de proximidad",
    ],
  },
  {
    slug: "san-miguel",
    name: "San Miguel",
    zona: "Oeste",
    referencia:
      "San Miguel reúne universidades, el Centro Comercial Plaza San Miguel y alto flujo de jóvenes, familias y trabajadores.",
    zonas: [
      "Plaza San Miguel y Av. La Marina",
      "Av. Universitaria (zona universitaria PUCP)",
      "Av. Costanera y parque Las Leyendas",
    ],
  },
  {
    slug: "barranco",
    name: "Barranco",
    zona: "Sur",
    referencia:
      "Barranco es el distrito cultural y creativo de Lima, con alta concentración de marcas lifestyle, bares y eventos de marca.",
    zonas: [
      "Puente de los Suspiros y centro histórico",
      "Av. Grau y Av. El Sol (zona gastronómica)",
      "Av. San Martín y galerías de arte",
    ],
  },
  {
    slug: "surquillo",
    name: "Surquillo",
    zona: "Sur",
    referencia:
      "Surquillo combina comercio tradicional en mercados con zonas residenciales y alto volumen de tráfico en puntos de venta.",
    zonas: [
      "Mercado de Surquillo N°1 y N°2",
      "Av. Angamos Oeste y Tomás Marsano",
      "Av. República de Panamá (frontera Miraflores)",
    ],
  },
  {
    slug: "los-olivos",
    name: "Los Olivos",
    zona: "Norte",
    referencia:
      "Los Olivos es el principal hub comercial del Cono Norte con Mega Plaza, centros empresariales y mercados de gran escala.",
    zonas: [
      "Mega Plaza y Av. Alfredo Mendiola",
      "Av. Universitaria Norte y zona empresarial",
      "Parque Zonal Sinchi Roca y entorno",
    ],
  },
  {
    slug: "san-juan-de-lurigancho",
    name: "San Juan de Lurigancho",
    zona: "Este",
    referencia:
      "San Juan de Lurigancho es el distrito más poblado de Lima, con enorme potencial de consumo masivo y comercio de proximidad.",
    zonas: [
      "Av. Gran Chimú y Av. Próceres de la Independencia",
      "Mercado Unicachi y zona comercial Zárate",
      "Av. Fernando Wiese y corredor industrial",
    ],
  },
  {
    slug: "ate",
    name: "Ate",
    zona: "Este",
    referencia:
      "Ate es un corredor industrial y comercial con alta concentración de industria, logística y comercio en Santa Clara y Vitarte.",
    zonas: [
      "Av. Nicolás Ayllón y Santa Clara",
      "Parque Industrial Ate Vitarte",
      "Agustino Plaza y corredor Carretera Central",
    ],
  },
  {
    slug: "la-victoria",
    name: "La Victoria",
    zona: "Centro",
    referencia:
      "La Victoria es uno de los distritos comerciales de mayor volumen en Lima, con Gamarra, mercados mayoristas y comercio activo.",
    zonas: [
      "Gamarra (Av. Aviación y Av. México)",
      "Mercado de Frutas y Av. 28 de Julio",
      "Av. México y zona industrial textil",
    ],
  },
  {
    slug: "callao",
    name: "Callao",
    zona: "Oeste",
    referencia:
      "Callao es el principal puerto del Perú con zona industrial activa, comercio portuario y residencias de trabajadores y familias.",
    zonas: [
      "Av. Argentina y zona portuaria",
      "Av. Faucett y entorno aeroportuario",
      "Centro Comercial Minka y Av. Gambetta",
    ],
  },
];

export function getDistrito(slug: string): Distrito | undefined {
  return DISTRITOS.find((d) => d.slug === slug);
}
